export const blogData = [
    {
        slug: 'baic-safety-assurance-system',
        title:
            'SAFETY AS FOUNDATION, INNOVATION AS DIRECTION: BAIC’S JOURNEY IN BUILDING A COMPREHENSIVE SAFETY ASSURANCE SYSTEM FOR INTELLIGENT CONNECTED VEHICLES',
        breadcrumb: ['Home', 'Newsroom', 'Company News'],
        heroImage: '/blogs/baic-hero.jpg',

        content: [
            {
                type: 'image',
                src: '/blogs/arcfox-city.jpg',
                caption: 'ARCFOX Alpha S (L3 Edition)',
            },
            {
                type: 'paragraph',
                text:
                    'On December 15, the ARCFOX Alpha S (L3 Edition) from BAIC Group officially received product access approval from the Ministry of Industry and Information Technology of the People’s Republic of China for autonomous driving vehicles, and will soon commence L3 conditional automated driving pilot operations in designated areas of Beijing.',
            },
            {
                type: 'paragraph',
                text:
                    'This milestone marks China’s autonomous driving technology progressively advancing toward mass production and represents a crucial transition for BAIC Group from technical validation to commercial application in the autonomous driving sector.',
            },
            {
                type: 'heading',
                level: 2,
                text: '01 Strategic elevation',
            },
            {
                type: 'subheading',
                text: 'Positioning safety as a group-level priority',
            },
            {
                type: 'paragraph',
                text:
                    'Since 2024, BAIC Group has leveraged its “Three-Year Leap Forward Initiative” to comprehensively advance intelligent transformation and upgrading, reconstructing its intelligent connected technology management system from R&D and production to verification, operations, and services.',
            },
            {
                type: 'paragraph',
                text:
                    'The group has built mass production R&D, manufacturing, and operational support capabilities for L3 and higher-level autonomous driving products, while constructing a “comprehensive safety” operational assurance system across research, production, supply, sales, and service.',
            },
            {
                type: 'paragraph',
                text:
                    'This system integrates enterprise, product, and operational assurance, covering design verification, functional safety, safety of the intended functionality, cybersecurity, data security, software update security, risk and incident management, and safety monitoring with emergency response.',
            },
            {
                type: 'heading',
                level: 2,
                text: '02 Systematic innovation',
            },
            {
                type: 'paragraph',
                text:
                    'BAIC Group has built a “one core, three rings” autonomous driving product safety development and assurance system to translate its safety philosophy into executable and verifiable engineering practices.',
            },
            {
                type: 'paragraph',
                text:
                    'The “one core” is the philosophy of “system-guaranteed safety”, with a development process oriented toward safety design and verification, embedding safety requirements from definition through system design and implementing a “dual closed-loop verification, three-level review” quality control mechanism.',
            },
            {
                type: 'paragraph',
                text:
                    'The first ring is a testing and verification assurance ring that uses a “three-pillar” framework of simulation testing, closed proving ground testing, and open road testing to align autonomous driving behavior with China’s complex road environment.',
            },
            {
                type: 'paragraph',
                text:
                    'The second ring is a process safety assurance ring, establishing a “five-in-one” process and a defense-in-depth security architecture across cloud, network, and vehicle ends, with lifecycle software update management for functional safety, intended functionality safety, cybersecurity, data security, and update security.',
            },
            {
                type: 'paragraph',
                text:
                    'The third ring is an operational monitoring assurance ring, using an enterprise safety monitoring platform for 7×24 h vehicle status monitoring and data analysis, forming a closed loop of “operational monitoring - data analysis - continuous optimization”.',
            },
            {
                type: 'image',
                src: '/blogs/baic-car-front.jpg',
            },
            {
                type: 'heading',
                level: 2,
                text: '03 Engineering practice',
            },
            {
                type: 'paragraph',
                text:
                    'Building on its safety philosophy and system, BAIC Group has developed the L3-level ARCFOX Alpha S (L3 Edition) autonomous driving vehicle that embodies multi-dimensional autonomous driving product safety concepts.',
            },
            {
                type: 'paragraph',
                text:
                    'The vehicle adopts a multi-layer redundant software and hardware architecture, featuring 34 high-performance sensors including 3 LiDARs for 360-degree environmental perception, plus full-chain redundancy across perception, decision-making, steering, braking, communication, power supply, and positioning.',
            },
            {
                type: 'paragraph',
                text:
                    'It also includes a complete and traceable autonomous driving data recording system to securely record operational status during system activation, supporting analysis, liability determination, and continuous optimization.',
            },
            {
                type: 'paragraph',
                text:
                    'To meet the overall safety objective of “safety performance superior to attentive human drivers”, the product has undergone more than 800,000 equivalent kilometers of testing across simulation, proving grounds, and public roads within its operational design domain.',
            },
            {
                type: 'paragraph',
                text:
                    'Multi-dimensional saturation testing has been carried out for functional safety, intended functionality safety, cybersecurity, data security, and software update security, providing a reference for mass production of conditional automated driving.',
            },
            {
                type: 'heading',
                level: 2,
                text: '04 Looking forward',
            },
            {
                type: 'paragraph',
                text:
                    'Obtaining L3-level autonomous driving vehicle product access approval is an important milestone in BAIC Group’s autonomous driving product safety practice, and the group will use this pilot as a new starting point to continuously improve its intelligent connected vehicle safety system.',
            },
            {
                type: 'paragraph',
                text:
                    'BAIC Group plans to deepen core technology and product R&D with an open, collaborative mindset, aiming to create safe and reliable intelligent connected vehicles and promote high-quality development of China’s intelligent automotive industry.',
            },
            {
                type: 'paragraph',
                text:
                    'By integrating its safety philosophy into every aspect of enterprise development and rigorously engineering every innovation, BAIC Group seeks to build the safety cornerstone of China’s intelligent connected vehicles and provide safer, more efficient mobility experiences for consumers.',
            },
        ],
    },
    {
        slug: 'baic-global-distributors-business-conference',
        title: 'BAIC GLOBAL DISTRIBUTORS BUSINESS CONFERENCE OPENS, THREE MAJOR BRANDS JOINTLY EMBARK ON A NEW STAGE OF GLOBAL DEVELOPMENT',
        breadcrumb: ['Home', 'Newsroom', 'News Release'],
        heroImage: 'https://www.baicglobal.com/file/common/image/2025/11/28/微信图片_20251128181558_593_142_20251128181932A036.jpg',
        content: [
            {
                type: 'paragraph',
                text: 'The 2025 BAIC Global Distributors Business Conference, themed “TO NEW VISTAS”, was held today in Guangzhou. More than 300 dealers, media representatives, and industry guests from around the world gathered to witness the new stage of BAIC’s internationalization strategy.'
            },
            {
                type: 'paragraph',
                text: 'This year’s convention brought together the three major brands—BAIC, ARCFOX, and STELATO—for the first time, marking the comprehensive upgrade of BAIC’s brand strategy and the official entry into a new stage of “three-brand synergy.”'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/cropper_20251128172710A005.webp',
                caption: 'Conference Highlights'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/ScreenShot_2025-11-28_172453_294_20251128172518A001.png',
                caption: 'Keynote Speech'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/cropper_20251128172649A004.webp',
                caption: 'Global Partners'
            },
            {
                type: 'paragraph',
                text: 'Over the past five years, BAIC has achieved leapfrog growth: annual sales increased from about 10,000 units in 2021 to nearly 70,000 units in 2025; the product portfolio expanded from ICE vehicles to hybrid and pure electric models; the ARCFOX and STELATO were fully launched overseas; the sales network expanded from more than 40 countries to more than 60; and the overseas team grew from 120 people to nearly 1,000, with global operational capabilities significantly enhanced.'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/blob_20251128174642A012.avif',
                caption: 'Global Growth'
            },
            {
                type: 'paragraph',
                text: 'In particular, over the past year, BAIC has made breakthroughs in several key markets. The production pace of the South Africa plant improved, and the “passenger–commercial collaboration” model continued to generate results. In the Gulf, North Africa, Southeast Asia, Central and South America, and other regions, multiple new models were successfully launched, accurately addressing local needs. The manufacturing, supply chain, and after-sales systems continued to mature, providing stable support for global dealers.'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/cropper_20251128105717A094.webp',
                caption: 'Strategic Markets'
            },
            {
                type: 'paragraph',
                text: 'Based on this progress, BAIC officially released its new overseas brand architecture: using BAIC as the corporate brand, and developing the three product brands BAIC, ARCFOX, and STELATO. ARCFOX is positioned as a comprehensive brand featuring new energy; BAIC is positioned as a comprehensive brand featuring off-road; and STELATO is positioned as a premium new energy brand. The three brands complement each other and jointly drive global development.'
            },
            {
                type: 'heading',
                level: 2,
                text: 'New Overseas Brand Architecture'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/39df32eafvb26805eaec8fa9bc8fb3fc_20251128174834A013.jpg',
                caption: 'Brand Architecture'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/de05de083neb4bd11c53b7a70a87ac3d_20251128174901A014.jpg',
                caption: 'ARCFOX'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/709edb9dcqbd1bd8f06d7047b5819baa_20251128174935A015.jpg',
                caption: 'BAIC'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/34d816065ld5f864dbabe6193b473615_20251128175151A016.jpg',
                caption: 'STELATO'
            },
            {
                type: 'heading',
                level: 2,
                text: 'Looking Forward'
            },
            {
                type: 'paragraph',
                text: 'Looking toward the new journey, BAIC will focus on three core measures: building blockbuster products, expanding market coverage, and strengthening supply chain support, focusing on key markets, enhancing localized operations, and working with leading enterprises such as CATL and Huawei to co-develop charging and swapping networks as well as intelligent connected platforms.'
            },
            {
                type: 'paragraph',
                text: 'Wang Jianhui, Chairman of BAIC, stated: “The next five years is an important period for BAIC International\'s transition. With the full support of BAIC Group, we will concentrate our top resources to push our global strategy. We look forward to joining hands with all of you to ride this wave—bringing more high-quality products to markets worldwide. And we will provide global customers mobility solutions better than expectations.”'
            },
            {
                type: 'image',
                src: 'https://www.baicglobal.com/file/common/image/2025/11/28/49049f3e8nf3aac6feacb425084ccad9_20251128175308A017.jpg',
                caption: 'Wang Jianhui, Chairman of BAIC'
            }
        ]
    },
    {
        slug: 'baic-ranked-fortune-500',
        title: 'BAIC Ranked in Fortune Global 500',
        breadcrumb: ['Home', 'Newsroom', 'Corporate'],
        heroImage: 'https://images.pexels.com/photos/70912/pexels-photo-70912.jpeg',
        content: [
            {
                type: 'paragraph',
                text: 'BAIC Group has achieved a prestigious ranking in the Fortune Global 500, showcasing our commitment to excellence and innovation in the automotive industry. This recognition reflects our robust growth strategy and global expansion efforts.',
            },
            {
                type: 'paragraph',
                text: 'The ranking is a testament to the hard work of our global team and the trust our customers place in our vehicles. We continue to push the boundaries of automotive technology and sustainability.',
            },
            {
                type: 'image',
                src: 'https://images.pexels.com/photos/70912/pexels-photo-70912.jpeg',
                caption: 'Global Recognition'
            }
        ]
    },
    {
        slug: 'smart-baic-technology-launch',
        title: 'Smart BAIC Technology Launch',
        breadcrumb: ['Home', 'Newsroom', 'Technology'],
        heroImage: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
        content: [
            {
                type: 'paragraph',
                text: 'Introducing cutting-edge smart vehicle technology that redefines driving experience with AI-powered features and connected services. Our new platform integrates seamless connectivity, advanced safety features, and autonomous driving capabilities.',
            },
            {
                type: 'paragraph',
                text: 'This launch marks a significant milestone in our journey towards intelligent mobility. Drivers can now experience a more intuitive and personalized interaction with their vehicles.',
            },
            {
                type: 'image',
                src: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
                caption: 'Intelligent Cockpit'
            }
        ]
    },
    {
        slug: 'new-manufacturing-facility-opens',
        title: 'New Manufacturing Facility Opens',
        breadcrumb: ['Home', 'Newsroom', 'Manufacturing'],
        heroImage: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
        content: [
            {
                type: 'paragraph',
                text: 'BAIC opens state-of-the-art manufacturing facility featuring advanced robotics and sustainable production processes. This facility increases our production capacity significantly while reducing our carbon footprint.',
            },
            {
                type: 'paragraph',
                text: 'Located in a strategic hub, the new plant will serve both local and international markets, ensuring faster delivery times and maintaining the highest standards of quality control.',
            },
            {
                type: 'image',
                src: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
                caption: 'State-of-the-art Production Line'
            }
        ]
    }
];
